import React from 'react';
import { BeatLoader } from 'react-spinners';
import styled from 'styled-components';

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
`;

const LoadingScreen = () => (
  <LoadingContainer>
    <BeatLoader color="#a5b4fc" size={14} />
  </LoadingContainer>
);

export default LoadingScreen;
